<template>
  <div class="box14">
    <pageTitle title="高质量课程" text />
    <div class="wrap">
      <commonFreeVideo class="box" :videoList="videoList" />

      <!-- <div class="btn" @click="toLink('https://m.boxuegu.com/')"> -->
      <div class="btn" @click="zixun('获取更多')">
        获取更多
        <span>></span>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commonFreeVideo from "../common/common-free-video.vue";
export default {
  components: {
    pageTitle,
    commonFreeVideo,
  },
  data() {
    return {
      videoList: [
        {lessonName:"初学者想要的JavaScript入门课",
          url: "https://www.boxuegu.com/freecourse/detail-4407.html",
          img: require("../../../assets/coursePage/web/box14/1.jpg"),
        },
        {lessonName:"Web前端HTML5+CSS3进阶",
          url: "https://www.boxuegu.com/freecourse/detail-1589.html",
          img: require("../../../assets/coursePage/web/box14/2.jpeg"),
        },
        {lessonName:"前端基础技能HTML入门到进阶",
          url: "https://www.boxuegu.com/freecourse/detail-1587.html",
          img: require("../../../assets/coursePage/web/box14/3.jpeg"),
        },
        {lessonName:"零基础玩转微信小程序",
          url: "https://www.boxuegu.com/freecourse/detail-1585.html",
          img: require("../../../assets/coursePage/web/box14/4.jpeg"),
        },
        {lessonName:"Vue.js基础入门开发",
          url: "https://www.boxuegu.com/freecourse/detail-1546.html",
          img: require("../../../assets/coursePage/web/box14/05.png"),
        },
        {lessonName:"JavaScript语法零基础入门",
          url: "https://www.boxuegu.com/freecourse/detail-1559.html",
          img: require("../../../assets/coursePage/web/box14/6.jpeg"),
        },
        {lessonName:"Uni-App从入门到实战",
          url: "https://www.boxuegu.com/freecourse/detail-2479.html",
          img: require("../../../assets/coursePage/web/box14/07.png"),
        },
        {lessonName:"HTML+CSS入门基础教程",
          url: "https://www.boxuegu.com/freecourse/detail-1254.html",
          img: require("../../../assets/coursePage/web/box14/08.png"),
        },
      ],
    };
  },
  methods: {
    zixun(name) {
      this.mai("HTML&JS+前端-就业课","获取更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box14 {
  padding: 80px 0px 0;
  width: 100%;
  background: url("../../../assets/coursePage/web/box14/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .box {
    margin-top: 48px;
  }
  .wrap {
    background: rgba(70, 162, 72, 0.06);
  }
  .btn {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: center;
    color: #00b589;
    padding-bottom: 88px;
  }
}
</style>
